import { styles } from "@repo/helpers";

import { useComplaintLists } from "../../../../tabs/complaints/editor";
import style from "./style.module.scss";
import { Props } from "./types";

export default function ComplaintLevel(props: Props) {
	const { component } = props;
	const { propertyValue } = component;
	const [complaintTypeId, ope] = propertyValue;
	const { activeLists: complaintLists } = useComplaintLists();
	const complaintType = complaintLists?.complaintTypeLevels.data.find((ct) => ct.id === complaintTypeId);
	const complaintTypeLevel = complaintType?.value || "N/A";
	const opeLevel = (
		<>
			<s>&nbsp;{complaintTypeLevel}&nbsp;</s>&nbsp;1
		</>
	);
	const level = ope && complaintTypeLevel && complaintTypeLevel !== "1" ? opeLevel : complaintTypeLevel;
	return (
		<div
			className={styles(style.displayGroup, component.extendedProperties.inline && style.inline)}
			id={component.linkName}
		>
			<span className={style.controlLabel}>Level</span>
			<span>&nbsp; {level}</span>
		</div>
	);
}
